import { p as proxyCustomElement, H, h, a as Host } from './index.js';

const columnsCss = ":host{--gap:0px;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;box-sizing:border-box;display:flex;flex-direction:row;flex-wrap:wrap;font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal;min-width:100%}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}:host([gutter=xs]){--gap:0.0625rem;gap:.25rem}:host([gutter=sm]){--gap:0.125rem;gap:.5rem}:host([gutter=md]){--gap:0.25rem;gap:1rem}:host([gutter=lg]){--gap:0.375rem;gap:1.5rem}:host([gutter=xl]){--gap:0.5rem;gap:2rem}";

const WuiColumns$1 = /*@__PURE__*/ proxyCustomElement(class WuiColumns extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    render() {
        return (h(Host, { key: 'f2680a8e77af58bf89580e8d1da92a4872611842' }, h("slot", { key: '0646285340ea09783787c5a5ce62dfdc99a48e7c' })));
    }
    static get style() { return columnsCss; }
}, [257, "wui-columns", {
        "gutter": [513]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-columns"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-columns":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiColumns$1);
            }
            break;
    } });
}
defineCustomElement$1();

const WuiColumns = WuiColumns$1;
const defineCustomElement = defineCustomElement$1;

export { WuiColumns, defineCustomElement };
